import { render, staticRenderFns } from "./paperAnalysis.vue?vue&type=template&id=51056f5f&scoped=true"
import script from "./paperAnalysis.vue?vue&type=script&lang=js"
export * from "./paperAnalysis.vue?vue&type=script&lang=js"
import style0 from "./paperAnalysis.vue?vue&type=style&index=0&id=51056f5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51056f5f",
  null
  
)

export default component.exports